!function () {
    var priceContainerSelector = ".ltk-product-price", newPriceSelector = ".ltk-newprice",
        olderPriceSelector = ".ltk-oldprice";

    function formatPrices() {
        $(".ltk-product-price").each((function (index) {
            try {
                formatPrice(this, ".ltk-oldprice"), formatPrice(this, ".ltk-newprice")
            } catch (e) {
                console.log(e)
            }
        }))
    }

    function formatPrice(parentNode, selector) {
        try {
            var element = $(parentNode).find(selector), innerHtml;
            isPriceFormatted(element.text()) || element.text("$" + parseFloat(element.attr("data-currency-usd")).toFixed(2).toString())
        } catch (e) {
            console.log(e)
        }
    }

    function isPriceFormatted(price) {
        return isNaN(price)
    }

    function hidePrices() {
        $(".ltk-product-price").each((function (index) {
            try {
                var olderPrice = getOlderPrice(this), newPrice = getNewPrice(this);
                Number(newPrice) >= Number(olderPrice) && hidePrice(this, ".ltk-oldprice")
            } catch (e) {
                console.log(e)
            }
        }))
    }

    function hidePrice(parentNode, selector) {
        $(parentNode).find(selector).css("display", "none")
    }

    function getOlderPrice(parentNode) {
        return getPrice(parentNode, ".ltk-oldprice")
    }

    function getNewPrice(parentNode) {
        return getPrice(parentNode, ".ltk-newprice")
    }

    function getPrice(parentNode, selector) {
        return $(parentNode).find(selector).attr("data-currency-usd")
    }

    $(document).ready((function () {
        setInterval((function () {
            hidePrices(), formatPrices()
        }), 1e3);

    }))
}();
